import {SEOManager} from "../../utilities/SEOManager";
import {Navbar} from "../../components/NavBar";
import React from "react";
import Footer from "../../sections/Footer/Footer";
import {Container, Feature, SectionTitle} from "../../components/LayoutHelpers";
import {IconLightning, IconPuzzle, IconRocket, IconTools} from "../../components/Icons";

export default function AvisoLegal() {
    return (
        <div id="inicio" className="page">
            <SEOManager/>
            <Navbar/>

            <main id="content">
                <section id="servicios" className="section-alt">
                    <Container>
                        <h2 className="h2">{"Aviso Legal"}</h2>
                        <p className="subtitle">{"En cumplimiento con el deber de información recogido en el artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa que el presente sitio web, https://compassia.es, es titularidad de:"}</p>
                        <p className="subtitle">{"Titular: Xavier Collado Sanchez"}</p>
                        <p className="subtitle">{"NIF: [NIF]"}</p>
                        <p className="subtitle">{"Domicilio: Barcelona"}</p>
                        <p className="subtitle">{"Correo electrónico: info@compassia.es"}</p>
                        <br/>

                        <h2 className="h2">{"Condiciones de uso"}</h2>
                        <p className="subtitle">{"El acceso y uso de este sitio web atribuye la condición de usuario, que acepta, desde dicho acceso y uso, las presentes condiciones de uso."}</p>
                        <br/>

                        <h2 className="h2">{"Propiedad Intelectual e Industrial"}</h2>
                        <p className="subtitle">{"Los contenidos de este sitio web (textos, imágenes, código, diseño, etc.) son titularidad de Compassia, o de terceros que han autorizado su uso. Queda prohibida su reproducción, distribución o modificación sin autorización expresa."}</p>
                        <br/>

                        <h2 className="h2">{"Limitación De Responsabilidad"}</h2>
                        <p className="subtitle">{"El titular no se hace responsable de los daños derivados del mal uso de la web, ni de los enlaces externos a sitios de terceros sobre los que no tiene control."}</p>

                    </Container>
                </section>

            </main>

            <Footer/>
        </div>
    );
}